export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YMptilss6yLUrwA.4b467621.woff2";